var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"BasicHeader"},[_c('div',{staticClass:"Header-details"},[_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-right":"20px","height":"32px"}},[_vm._t("title")],2),_c('div',{staticClass:"u-flex-grow"},[_vm._t("content")],2),_c('div',[_vm._t("tool")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }